import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Tecnico } from '../models/tecnico-model';

@Injectable({
  providedIn: 'root'
})
export class TecnicoService {

  constructor(protected http: HttpClient, @Inject('BASE_URL') protected baseUrl: string) { }

  getTecnicos() {
    return this.http.get(`${this.baseUrl}api/Tecnico/`);
  }

  getTecnicoById(id: number) {
    return this.http.get(`${this.baseUrl}api/Tecnico/${id}`);
  }

  put(item): Observable<Tecnico> {
    const url = `${this.baseUrl}api/Tecnico/${item.id}`;
    console.log("put: " + url);
    return this.http.put<Tecnico>(url, item);
  }

  post(item): Observable<Tecnico> {
    const url = `${this.baseUrl}api/Tecnico`;
    console.log("post: " + url);
    return this.http.post<Tecnico>(url, item);
  }

  postTecnicosAgregados(tecnicosList: any[], tasacionId: any) {
    const url = `${this.baseUrl}api/Tecnico/TecnicosAgregados/${tasacionId}`;
    console.log("post: " + url);
    return this.http.post<any[]>(url, tecnicosList);
  }

  delete(id: number) {
    const url = `${this.baseUrl}api/Tecnico/${id}`;
    return this.http.delete<Tecnico>(url);
  }

}
